import { useEffect, useState } from "react";

import styles from "../../../../styles/beneficios/ContemplateCustomers.module.scss";

import { StandaloneCouponsAPI } from "../../../../providers/StandaloneCouponsAPI";
import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { SuccessIcon } from "../../../components/Icons";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Message } from "../../../components/Message";
import { Icon } from "../../../components/core/Icon";
import { Phone } from "../../../utils/Phone";

export default function ContemplateCustomers({
  embeddedComponent,
  onClose,
  onUpdateCustomerList,
  couponId,
  onFinishContemplation,
}) {
  const [customers, setCustomers] = useState([]);
  const [customerPhone, setCustomerPhone] = useState("");
  const [saving, setSaving] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (onUpdateCustomerList) {
      onUpdateCustomerList(customers);
    }
  }, [customers]);

  const addCustomer = () => {
    if (customerPhone.length === 0) return;

    const customer = customerPhone.replace(/\D/g, "");
    setCustomers([customer, ...customers]);

    setCustomerPhone("");
  };

  const removeCustomer = (customer) => {
    setCustomers(
      customers.filter((currentCustomer) => currentCustomer != customer)
    );
  };

  const saveCustomers = async () => {
    setSaving(true);

    const saveReq = await StandaloneCouponsAPI.assignStandaloneCoupons(
      couponId,
      customers
    );
    setSaving(false);

    const assignments = saveReq.getData({})?.assignments;
    const assignmentErrors =
      assignments?.length > 0
        ? assignments.filter((assignment) => assignment.success === false)
        : [];

    if (saveReq.getErrors([]).length > 0) {
      alert({ text: saveReq.getErrors()[0] });
      return null;
    }

    if (assignmentErrors?.length > 0) {
      const errorCustomers = assignmentErrors.map((error) => error.phone);
      alert({
        text: `Não foi possível contemplar os seguintes clientes: ${errorCustomers.join(
          ", "
        )}`,
      });

      return;
    }

    if (!embeddedComponent) {
      setShowSuccess(true);

      if (onFinishContemplation) {
        onFinishContemplation();
      }
    }
  };

  return (
    <div className={styles.createCustomer}>
      {!showSuccess && (
        <>
          <Message className="mb-20">
            Ao contemplar clientes por meio dessa funcionalidade, seus clientes
            não conseguirão mais adicionar este benefício manualmente ao clube.
            Isto é feito para evitar vazamento de benefícios.
          </Message>
          <Label>Insira o número de telefone do cliente</Label>
          <Input
            onChange={(e) => setCustomerPhone(e.target.value)}
            placeholder="(00) 00000-0000"
            mask="(99) 99999-9999"
          />
          <Button
            className="mt-20 w-100"
            onClick={addCustomer}
            disabled={customerPhone.length < 15}
          >
            Adicionar
          </Button>

          <Hairline />

          <Label>Clientes ({customers.length})</Label>

          {customers.length === 0 ? (
            <div className={styles.empty}>
              <div className={styles.icon}>
                <Icon name="user" />
              </div>

              <p>Não há clientes adicionados.</p>
            </div>
          ) : (
            <div className={styles.customers}>
              {customers.map((customer) => (
                <div className={styles.customer} key={customer}>
                  <p>{Phone.format(customer)}</p>
                  <div
                    className={styles.remove}
                    onClick={() => removeCustomer(customer)}
                  >
                    <i className="far fa-times" />
                  </div>
                </div>
              ))}
            </div>
          )}

          {!embeddedComponent && (
            <div className={styles.footer}>
              <Button
                className="w-100"
                design="primary"
                onClick={saveCustomers}
                disabled={saving || customers?.length == 0}
                loading={saving}
              >
                Contemplar
              </Button>
            </div>
          )}
        </>
      )}

      {showSuccess && (
        <div className={styles.success}>
          <div className={styles.successIcon}>
            <SuccessIcon />
          </div>
          <p>Os clientes foram contemplados com o cupom.</p>

          <div className={styles.footer}>
            <Button className="w-100" onClick={onClose}>
              Fechar
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
